export default "__VITE_ASSET__DVyE9pXu__"